import React from 'react'
import { IconSVGType } from '../../../types/icons'
import { FileExtension } from '../../../utils/files'
import FileBMPIcon from './FileBMP'
import FileCSVIcon from './FileCSV'
import FileDOCIcon from './FileDOC'
import FileGIFIcon from './FileGIF'
import FileJPGIcon from './FileJPG'
import FilePDFIcon from './FilePDF'
import FilePNGIcon from './FilePNG'
import FileXLSIcon from './FileXLS'

export interface FileIconProps {
  className?: string,
  extension: FileExtension,
  iconProps?: IconSVGType
}

const FILE_ICONS = new Map<string, Function>([
  [FileExtension.BMP, FileBMPIcon],
  [FileExtension.CSV, FileCSVIcon],
  [FileExtension.DOC, FileDOCIcon],
  [FileExtension.DOCX, FileDOCIcon],
  [FileExtension.GIF, FileGIFIcon],
  [FileExtension.JPG, FileJPGIcon],
  [FileExtension.JPEG, FileJPGIcon],
  [FileExtension.PDF, FilePDFIcon],
  [FileExtension.PNG, FilePNGIcon],
  [FileExtension.XLS, FileXLSIcon],
  [FileExtension.XLSX, FileXLSIcon],
])

/**
 * @param {FileIconProps} props
 * @param {object} props.className - Class name to customize look & feel of the icon.
 * @param {object} props.extension - File extension to identify the icon.
 * @param {object} props.iconProps (Optional) - Styles to customize look & feel of the component.
 */
const FileIcon = (props: FileIconProps) => {
  const IconComponent = FILE_ICONS.get(props.extension)
  if (!IconComponent) {
    return <></>
  }
  return <IconComponent className={props.className} {...props.iconProps} />
}

export default FileIcon